module.exports = __webpack_public_path__ + "img/filter-f.79590def.svg";